var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-left subtitle-2 font-weight-bold d-inline-block"},[_c('transition',{attrs:{"name":"price-change","mode":"out-in"}},[_c('span',{key:_vm.formattedPrice,staticClass:"gradient-text"},[_vm._v(_vm._s(_vm.displayValue))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }